.sensor {
  height: 1px;
  pointer-events: none;
  flex-shrink: 0;

  &[data-placement='top'] {
    position: absolute;
    top: var(--tolerance, 3px);
  }

  &[data-placement='bottom'] {
    position: relative;
    bottom: var(--tolerance, 3px);
    margin-top: -1px;
  }
}
